document.addEventListener('DOMContentLoaded', () => {
  const thumbsSwiperEl = document.querySelector('.product-thumbs');
  const mainSwiperEl = document.querySelector('.product-main');

  const thumbsSwiper = new Swiper(thumbsSwiperEl, {
    direction: 'vertical',
    slidesPerView: 6,
    spaceBetween: 10,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.thumb-next',
      prevEl: '.thumb-prev'
    },
    breakpoints: {
      0: { direction: 'horizontal', slidesPerView: 5, spaceBetween: 12 },
      576: { direction: 'horizontal', slidesPerView: 5, spaceBetween: 12 },
      768: { direction: 'vertical', slidesPerView: 6, spaceBetween: 10 },
      1024: { direction: 'vertical', slidesPerView: 6, spaceBetween: 10 }
    }
  });

  const mainSwiper = new Swiper(mainSwiperEl, {
  slidesPerView: 1,
  observer: true,
  observeParents: true
});

  mainSwiperEl.swiper = mainSwiper;
  thumbsSwiperEl.swiper = thumbsSwiper;

  function getThumbsPerView() {
    const w = window.innerWidth;
    if (w >= 1024) return 6;
    if (w >= 768) return 5;
    if (w >= 576) return 5;
    return 4;
  }

  function scrollThumbsCenter(index) {
    const thumbsPerView = getThumbsPerView();
    const centerIndex = Math.max(0, index - Math.floor(thumbsPerView / 2));
    //  thumbsSwiper.slideTo(centerIndex);
     thumbsSwiper.slideTo(centerIndex, 0);

    thumbsSwiper.slides.forEach((s, i) => {
      s.classList.toggle('swiper-slide-thumb-active', i === index);
    });
  }

  window.scrollThumbsCenter = scrollThumbsCenter;

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      scrollThumbsCenter(mainSwiper.activeIndex);
    }, 150);
  });

  mainSwiper.on('slideChange', () => {
    scrollThumbsCenter(mainSwiper.activeIndex);
  });

  thumbsSwiper.slides.forEach((slide) => {
    slide.addEventListener('click', () => {
      const currentIndex = Array.from(thumbsSwiper.slides).indexOf(slide);
      if (currentIndex === -1) return;
      mainSwiper.slideTo(currentIndex);
      scrollThumbsCenter(currentIndex);
    });
  });

  scrollThumbsCenter(0);
}); 


document.addEventListener('DOMContentLoaded', function () {
  const buttonWrapper = document.querySelector('.cst-btn-quantiti-bar');
  const addbuttonWrapper = document.querySelector('.product-form__buttons');

  if (!buttonWrapper) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          addbuttonWrapper.classList.remove('stickybutton');
        } else {
          addbuttonWrapper.classList.add('stickybutton');
        }
      });
    },
    {
      threshold: 0.1
    }
  );

  observer.observe(buttonWrapper);
});
    
 

